'use client'

import { LocalizedErrorPage, type StorefrontErrorBoundaryProps } from '@/components/ErrorPage'

export default function ErrorBoundary(props: StorefrontErrorBoundaryProps) {
  return <LocalizedErrorPage {...props} />
}
